import { createMuiTheme } from '@material-ui/core/styles';
import { black, blue, hoverBlue, red } from '../assets/ui/colors';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: blue,
        },
        secondary: {
            main: hoverBlue,
        },
        error: {
            main: red,
        }
    },
    typography: {
        fontFamily: 'OpenSans',
        color: black,
    },
    a: {
        textDecoration: 'none',
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': 'OpenSans',
            },
        },
        MuiButton: {
            root: {
                boxShadow: 'none !important',
                borderRadius: '6px',
                fontWeight: 600,
                letterSpacing: '0.31px',
            }
        }
    },
});

export default theme;
